import { render, staticRenderFns } from "./GateBanner.vue?vue&type=template&id=3035ee76&scoped=true"
import script from "./GateBanner.vue?vue&type=script&lang=js"
export * from "./GateBanner.vue?vue&type=script&lang=js"
import style0 from "./GateBanner.vue?vue&type=style&index=0&id=3035ee76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3035ee76",
  null
  
)

export default component.exports